<template>
	<PageContainer size="s">
		<div>
			<p v-if="loading">
				Authentification en cours...
			</p>
		</div>
	</PageContainer>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import UserMixin from '@/mixins/userMixin';
	const MixinsDeclaration = mixins(UserMixin);
	import AuthService from '@/services/auth';

	@Component<AuthAmeliPro>({
		created() {
			const psbenToken: string | null | undefined = this.$route.query
				.psben as string;
			// Appel à l'API avec le jeton PSBEN 2
			this.authenticateWithPsbenToken(psbenToken);
		}
	})
	export default class AuthAmeliPro extends MixinsDeclaration {
		loading = true;
		messageErreur =
			'Votre activité n\'étant liée à aucune donnée de ce service, vous n\'avez actuellement pas d\'accès à l\'application Pegase . ';

		async authenticateWithPsbenToken(PsbenToken: string): Promise<void> {
			try {
				// Redirige vers la page d'accueil qu'après vérification authentification et présence du jeton
				const authenticationResult = await AuthService.getPsBenUserFromApi(
					PsbenToken
				);
				if (authenticationResult) {
					// Stockage des info dans le store
					await this.$store.dispatch('authentication/storeAuthentication');
					await this.$store.dispatch('authentication/storeUserInformation');

					if (this.$store.getters['authentication/isLoggedIn']) {
						const utilisateurExterneInfo = this.utilisateurExterneInfo;
						// TODO vérifier si toujours utile (index.ts L59)
						// Vérification si l'utilisateur a une adresse email
						if (!utilisateurExterneInfo.email) {
							this.$router.push('/create-email');
							return;
						}
						if (!utilisateurExterneInfo.cguAccepted) {
							this.$router.push('/cgu');
							this.$store.dispatch('notification/add', {
								type: 'message',
								message:
									'L\'utilisation du service PEGASE requiert votre acceptation des CGU en cliquant sur le bouton \'ACCEPTER LES CGU\''
							});
						}

						this.$router.push('/gardes/dpa');
					}
				} else {
					this.$store.dispatch('notification/add', {
						type: 'error',
						message: this.messageErreur
					});
				}
			} catch (error) {
				this.$store.dispatch('notification/add', {
					type: 'error',
					message: 'Une erreur est survenue lors de l\'identification'
				});
			}
		}
	}
</script>
